import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";

import { UitkSpacing } from "uitk-react-spacing";
import { UitkBreadcrumbs } from "uitk-react-breadcrumbs";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

import { ViewProps } from "../../typings";

export const DefaultView: React.FC<ViewProps> = (props) => {
  const {
    id,
    fmId,
    fmTitleId,
    breadcrumbsWithAnalytics,
    isBreadcrumbsMenuOpen,
    menuAnalytics,
    onBreadcrumbsMenuTriggerClick,
    crossLOBMenuContainer,
  } = props;

  return (
    <div className="Breadcrumbs" id={id} data-fm={fmId} data-fm-title-id={fmTitleId}>
      <UitkLayoutFlex justifyContent="space-between" alignItems="center" className="breadcrumbs-alignment">
        <UitkLayoutFlexItem>
          <Viewport>
            <ViewSmall>
              <UitkSpacing padding={{ blockstart: "one" }}>
                <UitkBreadcrumbs
                  crumbs={breadcrumbsWithAnalytics}
                  crumbsToDisplay={1}
                  isOpen={isBreadcrumbsMenuOpen}
                  menuAnalytics={menuAnalytics}
                  onTriggerClick={onBreadcrumbsMenuTriggerClick}
                />
              </UitkSpacing>
            </ViewSmall>
            <ViewMedium>
              <UitkSpacing padding={{ block: "two" }}>
                <UitkBreadcrumbs crumbs={breadcrumbsWithAnalytics} />
              </UitkSpacing>
            </ViewMedium>
          </Viewport>
        </UitkLayoutFlexItem>
        {crossLOBMenuContainer}
      </UitkLayoutFlex>
    </div>
  );
};
